<template>
  <div style="height: calc(100vh - 120px)">
    <el-row :gutter="20" style="height: calc(100% - 20px)">
      <el-col :span="6" :xs="24" class="h-full">
        <el-card class="m-l-15 m-t-15 m-b-15 h-full">
          <div class="o-y-auto noscroll" style="height: calc(100vh - 160px)">
            <h2 align="center">{{ solutionForm.solutionTitle || '' }}</h2>
            <div class="m-t-15 w-full">
              <ratio-div :radio-value="75">
                <div class="w-full h-full absolute top-0 left-0">
                  <img class="w-full h-full" v-img-url="solutionForm.coverPath" alt=""/>
                </div>
              </ratio-div>
            </div>
            <div class="m-v-10">
              适用作物：{{ solutionForm.cropTxt }}
            </div>
            <div class="m-v-10">
              防控时期：{{ solutionForm.periodTxt }}
            </div>
            <div class="m-v-10">
              防控对象：{{ solutionForm.preventionTarget }}
            </div>
            <!--            <div class="m-v-10">-->
            <!--              方案描述：{{ solutionForm.solutionDesc }}-->
            <!--            </div>-->
            <div class="m-v-10">
              容器水量：{{ solutionForm.waterConsumption }} 公斤
            </div>
            <div class="m-v-10">
              <div class="m-b-10">效果图例：</div>
              <img :key="index" v-for="(item,index) in solutionForm.attachLists" class="w-full"
                   v-img-url="item.filePath" alt=""/>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" :xs="24" class="h-full">
        <el-card class="m-r-15 m-t-15 m-b-15 h-full">
          <el-tabs class="h-full o-y-auto" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" :key="index" v-for="(item,index) in tabList">
              <component ref="component" :is="getComponent(index)" class="p-b-10" :solutionForm="solutionForm"
                         v-if="activeName === item.id">
              </component>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'
import CalculateUsage from './component/CalculateUsage'
import SolutionProduct from './component/SolutionProduct'
import RatioDiv from '../../../../components/common/RatioDiv'

export default {
  name: 'detail',
  components: {RatioDiv, SolutionProduct, CalculateUsage},
  data () {
    return {
      activeName: '0',
      tabList: [
        {
          id: '0',
          label: '方案产品'
        },
        {
          id: '1',
          label: '用量计算'
        }],
      cropSolutionId: 0,
      solutionForm: {}
    }
  },
  watch: {
    cropSolutionId: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.getCropSolutionDetail()
        } else {
          this.solutionForm = {}
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.cropSolutionId = parseInt(this.$route.query.solutionId || 0)
    },
    getCropSolutionDetail () {
      CropSolutionApi.cropSolutionDetail({id: this.cropSolutionId}, true).then(res => {
        this.solutionForm = {
          ...res.data,
          countWaterConsumption: res.data.waterConsumption,
          landNum: 1
        }
      })
    },
    getComponent (tabIndex) {
      let componentName = ''
      let index = parseInt(this.activeName || 0)
      if (parseInt(tabIndex) === index) {
        switch (index) {
          case 0:
            componentName = 'SolutionProduct'
            break
          case 1:
            componentName = 'CalculateUsage'
            break
        }
      }
      return componentName
    },

    handleClick () {

    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/detail.vue